import type { FaireProductEntity } from "../../entity_types/product";

export const p_wwm4rr2xgb: FaireProductEntity = {
  token: "p_wwm4rr2xgb",
  type: "product",
  name: "Stretchy Bracelet | 10 Color Mix Set | Evil Eye & Crystals",
  brandToken: "b_eh970f9ptb",
  brandName: "Loli",
  imageUrl:
    "https://cdn.faire.com/fastly/ebae04519df329ef82e80e0e2178b1b0669aad3db47d35e28103bf9c25470e95.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f92e59db70f2399793e3d1a466853f7a4d8f590d6fdc3c01c96598bc2ef9bfa2.jpeg",
    "https://cdn.faire.com/fastly/702be312e7804246fe153056101fc1d197408ebb2a2c58c8006070f2b3d90782.jpeg",
    "https://cdn.faire.com/fastly/70e5f3b6bb5c2ac8555baf8ce8f2eccc3fce49243a7c69cd64c228a4058daa18.jpeg",
    "https://cdn.faire.com/fastly/3e70acd365491e12687c204030f285f76d6ed6b2bf65829b6f9f9c68a4f28372.jpeg",
    "https://cdn.faire.com/fastly/aff5d21d8a1c63a82f1da1a3b8eaa34c5433eca13b1ddc9e8c42a694f3b3698d.jpeg",
    "https://cdn.faire.com/fastly/4d4bd6e2840052536d6f03c9343e92e8a99495eda8e11acc7bd3b62a8f339681.jpeg",
    "https://cdn.faire.com/fastly/66ab8842603327d65246bf7e5bab15d41f0398a1199817c6f2019531adc645f6.jpeg",
    "https://cdn.faire.com/fastly/10be972b42e8d5cc703ea9a127cd7441682103b7c5fae8b71157744637681729.jpeg",
    "https://cdn.faire.com/fastly/2e95b2c42df1e45df3c4433f801614a1718853d586efe97e22de1b64238523ee.jpeg",
    "https://cdn.faire.com/fastly/50b1ec09c2495ab58dc717289a6f6ebac49023e82b656117938142b8c52c2985.jpeg",
    "https://cdn.faire.com/fastly/959d862c739e25762ab5aaa22a6f4875d0524d536b16b34d551d785edef72007.jpeg",
    "https://cdn.faire.com/fastly/71faf33ee6efff29576409044e46d04dc5cdf23b6eadffe305575db8767329a2.jpeg",
    "https://cdn.faire.com/fastly/e5f9384dd671523b23b39ce1d4c2097625c6dfafd79db3954a1d506963784153.jpeg",
    "https://cdn.faire.com/fastly/71005c279f2dc174d4f06e8d69dccb35757cdf2bb2b1e82baf3eba69f436c92c.jpeg",
    "https://cdn.faire.com/fastly/547ba23db74984c64be0b10e3263c1251ed8e69b183e56e7efd3ab9fde019a10.jpeg",
  ],
  priceDollars: 1.39,
  description:
    "Bring color, sparkle, and protection together with these evileye crystal stretchy bracelets. Featuring vibrant crystal beads with the iconic evil eye charm, they’re a stylish way to add both fashion and meaning to any outfit. Designed with a stretchy band, they comfortably fit all wrist sizes.\n\n✔️ Top-Selling Style – Affordable, trendy, and fast-moving.\n✔️ One Size Fits All – Flexible band eliminates sizing issues.\n✔️ 10 Color Mix – A wide range of bold brights and soft pastels to suit every customer’s taste.\n✔️ Crystal Bead Design – Beautifully arranged 8 mm beads paired with the timeless evileye symbol.\n✔️ Lightweight & Comfortable – Perfect for everyday wear.\n✔️ Layer or Solo – Stack multiple colors or wear alone as a statement.\n✔️ Meaningful Gift – Represents protection, luck, and positivity, making it a thoughtful gift option.\n\nThese evileye crystal bracelets are a must-have for boutiques seeking fast-turning, affordable jewelry with cultural and spiritual appeal.",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:42.763Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
